import React from 'react';

const Hero = () => {
  return (
    <section id="hero" className="hero section">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6" data-aos="fade-right" data-aos-delay="100">
            <div className="hero-content">
              <h1>Transform Your Business Through AI-Powered Automation.</h1>
              <p>We create AI-powered digital solutions that accelerate growth and amplify your brand. From web experiences to automation and marketing, we drive your digital transformation.</p>
              <div className="hero-buttons">
                <a href="#contact" className="btn btn-primary me-2">Get Started</a>
                <a href="#services" className="btn btn-outline">Our Work</a>
              </div>
              <div className="hero-stats mt-4 d-flex gap-4">
                <div className="stat-item text-center">
                  <span class="stat-number"><span class="purecounter" data-purecounter-start="0" data-purecounter-end="150" data-purecounter-duration="1">150</span>+</span>
                  <span className="d-block stat-label">AI Systems Deployed</span>
                </div>
                <div className="stat-item text-center">
                  <span class="stat-number"><span class="purecounter" data-purecounter-start="0" data-purecounter-end="95" data-purecounter-duration="1">95</span>%</span>

                  <span className="d-block stat-label">Client Satisfaction</span>
                </div>
                <div className="stat-item text-center">
                  <span class="stat-number"><span class="purecounter" data-purecounter-start="0" data-purecounter-end="5" data-purecounter-duration="1">5</span>X</span>
                  <span className="d-block stat-label">ROI Per Project</span>
                </div>

              </div>
            </div>
          </div>
          <div className="col-lg-6" data-aos="fade-left" data-aos-delay="200">
            <div className="hero-visual">
              <div className="hero-image">
                <img src={process.env.PUBLIC_URL + '/assets/img/misc/misc-16.webp'} alt="Digital Agency Hero" className="img-fluid" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="hero-bg-elements">
        <div className="bg-shape shape-1"></div>
        <div className="bg-shape shape-2"></div>
        <div className="bg-particles"></div>
      </div>
    </section>
  );
};

export default Hero;
